import React from 'react'

import PropTypes from 'prop-types'
import { omit } from 'ramda'
import { useConnect } from 'redux-bundler-hook'

import { Typography } from '@mui/material'

import { datePropType, renderableType } from '~/src/Lib/PropTypes'
import { DATE_FORMATS, formattedDate, useBreakpoint } from '~/src/Lib/Utils'

const DefaultComponent = props => (
  <Typography align="left" color="primary" component="span" {...props} />
)

const nativeOmitter = omit(['color', 'inline', 'variant'])

const defaultBreakpointFormats = {
  xs: formattedDate.SHORT_DATE,
}
/**
 * Renders date-like using formattedDate utility
 * @component
 * @alias FormattedDate
 * @named_export FormattedDateComponent
 */
export const FormattedDateComponent = ({
  label = null,
  date,
  locale,
  format = undefined,
  component = null,
  native = false,
  transform = null,
  ...other
}) => {
  const breakpoint = useBreakpoint()
  const defaultFormat = defaultBreakpointFormats[breakpoint]
  const Parent = component && native ? component : DefaultComponent
  const formatted = formattedDate(date, format ?? defaultFormat)
  return (
    <Parent component={native ? undefined : component} {...(native ? nativeOmitter(other) : other)}>
      {label && typeof label !== 'string' ? label : null}
      {label && typeof label === 'string' ? `${label} ` : null}
      {transform ? transform(formatted) : formatted}
    </Parent>
  )
}

FormattedDateComponent.displayName = 'FormattedDate'

FormattedDateComponent.propTypes = {
  component: renderableType,
  date: datePropType.isRequired,
  format: PropTypes.oneOfType([
    PropTypes.shape({
      minute: PropTypes.string,
      hour: PropTypes.string,
      day: PropTypes.string,
      month: PropTypes.string,
      year: PropTypes.string,
    }),
    PropTypes.oneOf(Object.keys(DATE_FORMATS))
  ]),
  label: renderableType.nullable,
  locale: PropTypes.string.isRequired,
  native: PropTypes.bool,
  transform: PropTypes.func,
}

const Memoized = props => {
  const connectedProps = useConnect('selectLocale')
  return <FormattedDateComponent {...connectedProps} {...props} />
}

Object.assign(Memoized, DATE_FORMATS)
export default React.memo(Memoized)
